import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

async function fetchBlob(url: string): Promise<Blob> {
  const { data } = await api.get(url, { responseType: 'blob' });
  return data;
}

// Generic blob-fetch-as-object-URL hook for any authenticated image endpoint
// - a plain <img src> can't carry the JWT these endpoints require, so this
// fetches the bytes via axios and exposes an object URL instead. Shared by
// org/platform logos and catalog item/photo images.
export function useAuthedImageUrl(url: string | null, queryKey: unknown[]): string | null {
  const { data: blob } = useQuery({
    queryKey,
    queryFn: () => fetchBlob(url!),
    enabled: !!url,
    staleTime: 5 * 60_000,
  });

  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setObjectUrl(null);
      return;
    }
    const created = URL.createObjectURL(blob);
    setObjectUrl(created);
    return () => URL.revokeObjectURL(created);
  }, [blob]);

  return objectUrl;
}
